import { Checkbox } from '@/shared/ui'
import { routes } from '@/shared/config'
import { designTokens } from '@/shared/lib/design-tokens'
import { buildRouteWithReturnTo } from '@/shared/lib'

export type AuthAgreementCheckboxProps = {
  id: string
  checked?: boolean
  onCheckedChange?: (checked: boolean) => void
  errorText?: string
  legalLinksReturnTo?: string
}

export function AuthAgreementCheckbox({
  id,
  checked,
  onCheckedChange,
  errorText,
  legalLinksReturnTo,
}: AuthAgreementCheckboxProps) {
  const textId = `${id}-text`
  const userAgreementHref = buildRouteWithReturnTo(routes.userAgreement, legalLinksReturnTo)
  const privacyPolicyHref = buildRouteWithReturnTo(routes.privacyPolicy, legalLinksReturnTo)

  return (
    <div className="flex w-full flex-col" style={{ gap: designTokens.spacing.xs }}>
      <div
        className="flex w-full items-start"
        style={{
          gap: designTokens.spacing.xs,
          textAlign: 'left',
          justifyContent: 'flex-start',
          alignContent: 'flex-start',
        }}
      >
        <Checkbox
          id={id}
          checked={checked}
          onChange={(event) => onCheckedChange?.(event.target.checked)}
          aria-describedby={textId}
          label={
            <span
              id={textId}
              style={{
                color: designTokens.colors.text.primary,
                fontFamily: designTokens.typography.fontFamilies.primary,
                fontSize: designTokens.typography.body.xsNormal.size,
                lineHeight: designTokens.typography.body.xsNormal.lineHeight,
                fontWeight: designTokens.typography.body.xsNormal.weight,
                textAlign: 'left',
                display: 'block',
                width: '100%',
                wordBreak: 'normal',
                overflowWrap: 'anywhere',
              }}
            >
              Принимаю{' '}
              <a
                href={userAgreementHref}
                target="_blank"
                rel="noreferrer"
                style={{ textDecoration: 'underline' }}
              >
                пользовательское соглашение
              </a>{' '}
              и соглашаюсь с{' '}
              <a
                href={privacyPolicyHref}
                target="_blank"
                rel="noreferrer"
                style={{ textDecoration: 'underline' }}
              >
                правилами использования и обработки персональных данных
              </a>
            </span>
          }
        />
      </div>
      {errorText ? (
        <p
          style={{
            color: designTokens.colors.text.error,
            fontFamily: designTokens.typography.fontFamilies.primary,
            fontSize: designTokens.typography.body.xsNormal.size,
            lineHeight: designTokens.typography.body.xsNormal.lineHeight,
            fontWeight: designTokens.typography.body.xsNormal.weight,
            margin: 0,
          }}
        >
          {errorText}
        </p>
      ) : null}
    </div>
  )
}
